"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Compass } from "lucide-react";
export default function ExploreMoreCta() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="explore-more-cta" className="relative min-h-[70vh] w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed blur-sm scale-110" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/caribbean_horizon_sunset.png)"
    }} />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(188, 70%, 54%, 0.85) 0%, hsla(14, 100%, 69%, 0.75) 100%)"
    }} />

      {}
      <div ref={contentRef} className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="inline-flex items-center justify-center mb-6">
          <Compass className="size-12 text-white drop-shadow-lg" />
        </div>

        {}
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight leading-tight drop-shadow-lg">
          Discover Your Next Adventure
        </h2>

        {}
        <p className="text-lg md:text-xl text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
          Dive deeper into the heart of the Riviera Maya. Experience exclusive
          eco-luxury journeys crafted for the discerning traveler.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {}
          <Link to="/ContactPage">
            <Button size="lg" variant="outline" className="group px-8 py-5 text-base bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary-dark shadow-medium transition-all duration-300">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}